import { v4 as uuid } from "uuid";
import InvoiceAPI from "@/api/InvoiceAPI";

import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {INVOICE} from "@/actions/globalConst";
import { InvoiceModel } from "@/models/Invoice";
import DB from "@/models/DB";
import {InvoiceTimeRegistration} from "@/models/InvoiceTimeRegistration";

export const initialState = {
    customers: [],
    vatrates: [],
    from: null,
    to: null,
    products: [],
    key: "",
    invoice: null,
    invoices: [],
    view: INVOICE.IS_INIT,
    api_state: INVOICE.API_INIT,
    workTypes: [],
    customertimereg: null,
};

const InvoiceReducer = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
      resetState:  ((state, action) => {
        state.api_state = INVOICE.API_INIT;
      }),
      newInvoiceModel:  ((state, action) => {
        state.invoice = DB.newModel(null, InvoiceModel);
        state.invoice.setVatRates(state.vatrates);
        state.customertimereg = null;
        if(action.payload.customer) {
            state.invoice.customer = action.payload.customer;
        }
        state.key = uuid().slice(0, 8);
      })
      
    // omit existing reducers here
  },
  extraReducers(builder) {
    getTimeRegistrationForCustomer
    builder.addCase(getTimeRegistrationForCustomer.fulfilled, (state, action) => {
        if(action.payload.data.data) {
            console.debug("action.payload.data.dataaction.payload.data.dataaction.payload.data.data", action.payload.data)
            state.customertimereg = DB.newCollection(action.payload.data.data, InvoiceTimeRegistration);
        }
      state.api_state = INVOICE.API_SUCCES;
    }).addCase(getTimeRegistrationForCustomer.rejected, (state, action) => {
        state.api_state = INVOICE.API_FAILED;
    }).addCase(getTimeRegistrationForCustomer.pending, (state, action) => {
        state.api_state = INVOICE.API_PENDING; 
    });
    
    builder.addCase(getInvoiceFilters.fulfilled, (state, action) => {
        if(action.payload.data.workTypes) {
            state.workTypes = action.payload.data.workTypes;
        }
        console.debug("action.payload.data.dataaction.payload.data.dataaction.payload.data.data", action.payload.data)
        
        if(action.payload.data.data.data) {
            state.customertimereg = DB.newCollection(action.payload.data.data.data, InvoiceTimeRegistration);
            action.payload = state.customertimereg; 
        }
        
      state.api_state = INVOICE.API_SUCCES;
    }).addCase(getInvoiceFilters.rejected, (state, action) => {
        state.api_state = INVOICE.API_FAILED;
    }).addCase(getInvoiceFilters.pending, (state, action) => {
        state.api_state = INVOICE.API_PENDING; 
    });

    builder.addCase(invoiceInit.fulfilled, (state, action) => {
      state.from = action.payload.data.from;
      state.customers = action.payload.data.customers;
      state.vatrates = action.payload.data.vatrates;
      if(action.payload.data.worktype) {
        state.workTypes = action.payload.data.worktype;
      }
      state.view = INVOICE.VIEW_CREATE;
      state.key = uuid().slice(0, 8);
      
      state.invoice = new InvoiceModel(null, state.vatrates);
      state.view = INVOICE.IS_READY;
      state.api_state = INVOICE.API_SUCCES;
    }).addCase(invoiceInit.rejected, (state, action) => {
        state.api_state = INVOICE.API_FAILED;
    }).addCase(invoiceInit.pending, (state, action) => {
        state.api_state = INVOICE.API_PENDING;
    });
    
    builder.addCase(getInvoices.fulfilled, (state, action) => {
      state.invoices = action.payload.data.data.data;
      state.invoice = new InvoiceModel();
      state.view = INVOICE.IS_READY;
      state.api_state = INVOICE.API_SUCCES;
    }).addCase(getInvoices.rejected, (state, action) => {
        state.api_state = INVOICE.API_FAILED;
    }).addCase(getInvoices.pending, (state, action) => {
        state.api_state = INVOICE.API_PENDING;
    });

    builder.addCase(createInvoice.fulfilled, (state, action) => {
      state.invoices = action.payload.data.data.data;
      state.invoice = new InvoiceModel(null, state.vatrates);
      state.view = INVOICE.IS_READY;
      state.api_state = INVOICE.API_SUCCES;
      state.key = uuid().slice(0, 8);
    }).addCase(createInvoice.rejected, (state, action) => {
        state.api_state = INVOICE.API_FAILED;
    }).addCase(createInvoice.pending, (state, action) => {
        state.api_state = INVOICE.API_PENDING;
    });

    builder.addCase(recreateInvoice.fulfilled, (state, action) => {
        if(action.payload.data.data.data) {
            state.invoices = action.payload.data.data.data;
        }
      //state.invoices = action.payload.data.data.data;
      //state.invoice = new InvoiceModel(null, state.vatrates);
      state.view = INVOICE.IS_READY;
      state.api_state = INVOICE.API_SUCCES;
      state.key = uuid().slice(0, 8);
    }).addCase(recreateInvoice.rejected, (state, action) => {
        state.api_state = INVOICE.API_FAILED;
    }).addCase(recreateInvoice.pending, (state, action) => {
        state.api_state = INVOICE.API_PENDING;
    });


    builder.addMatcher(
      (action) => action.type.endsWith('chat/receiveMessage'),
      (state, action) => {
          if(action?.payload?.event?.data) {
          let item = JSON.parse(action?.payload?.event?.data);
          
            if(item?.data?.invoiceModel) {
                for(let i in state.invoices) {
                    if(state.invoices[i].key == item?.data?.invoiceModel.key) {
                        state.invoices[i].state = item?.data?.invoiceModel.state;
                        state.invoices[i].download_link = item?.data?.invoiceModel.download_link;
                        break;
                    } 
                }
                state.key = uuid().slice(0, 8);
            }
//            if(action?.payload?.data?.data?.notification) {
//                state.notifications.push(action?.payload?.data?.data?.notification);
//            }
            }
       });

            
                   
       builder.addMatcher(
         (action) => (action.type.endsWith('remove_bse_setting/fulfilled') || action.type.endsWith('basesettings_api_save/fulfilled')),
         (state, action) => {
       
            if(action.payload.data.workTypes) {
                state.workTypes = action.payload.data.workTypes;
            }

            
            });
       
    builder.addMatcher(
      (action) => action.type.endsWith('switchtenant'),
      (state, action) => {
            state.invoices = [];
            state.invoice = [];
            state.products = [];
            state.customers = [];
            state.vatrates = [];
            state.view = INVOICE.IS_INIT;
            state.api_state = INVOICE.API_INIT;
       });
    
  }
});

export const invoiceInit = createAsyncThunk(
  INVOICE.API_INIT,
  async (data, event) => {
    let response = null;
    try {
          response = await InvoiceAPI.newInvoiceInit(data)
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getInvoices = createAsyncThunk(
  "overview",
  async (data, event) => {
    let response = null;
    try {
          response = await InvoiceAPI.getAll()
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const createInvoice = createAsyncThunk(
  INVOICE.API_CREATE_NEW,
  async (data, event) => {
    let response = null;
    try {
          response = await InvoiceAPI.createNewInvoice(data)
    } catch (err) {
        
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const recreateInvoice = createAsyncThunk(
  INVOICE.API_RECREATE,
  async (data, event) => {
    let response = null;
    try {
          response = await InvoiceAPI.recreateInvoice(data.key, {})
          return response.data;
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const getInvoiceFilters = createAsyncThunk(
  INVOICE.API_GET_INVOICE_FILTERS,
  async (data, event) => {
    let response = null;
    try {
          response = await InvoiceAPI.getCustomerTimeRegistrations(data);
          return response;
    } catch (err) {
        
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getTimeRegistrationForCustomer = createAsyncThunk(
  INVOICE.API_GET_CUSTOMER_TIMEREG,
  async (data, event) => {
    let response = null;
    try {
          response = await InvoiceAPI.getCustomerTimeRegistrations(data)
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const getInvoiceAPIState = (state) => state.invoice;;
export const { resetState, newInvoiceModel } = InvoiceReducer.actions;
export default InvoiceReducer.reducer